import {
  ColumnDef,
  FilterFn,
  Row,
  SortingFn,
  TableOptions,
  TableState,
} from "@tanstack/react-table";
import { InitialTableState } from "@tanstack/table-core";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material";

type CellStylesCbType = (row: Row<any>) => SxProps<Theme>;
export const isCellStylesCallable = (
  cellStyles: any,
): cellStyles is CellStylesCbType => typeof cellStyles === "function";

declare module "@tanstack/table-core" {
  interface FilterFns {
    tagFilter: FilterFn<unknown>;
    defaultFilter: FilterFn<unknown>;
    moneyFilter: FilterFn<unknown>;
    dateFilter: FilterFn<unknown>;
    globalFilter: FilterFn<unknown>;
    strictEqualityFilter: FilterFn<unknown>;
    cpuFilter: FilterFn<unknown>;
    accountDataFilter: FilterFn<unknown>;
    createdByFilter: FilterFn<unknown>;
  }
  interface SortingFns {
    sortWithConvertingToNumber: SortingFn<unknown>;
    sortWithCreatedBy: SortingFn<unknown>;
  }
  // @ts-expect-error | types looks ok, can't understand what's the reason
  interface ColumnMeta {
    alwaysShowSortIcon?: boolean;
    showSortRemoveIcon?: boolean;
    sticky?: "left" | "right";
    hideFromSettings?: boolean;
    cellStyles?: SxProps<Theme> | CellStylesCbType;

    // if the title does not just text, this can be used to display in other places so as not to render unnecessary components.
    headerTitle?: string;
    customHeaderTooltip?: string;
  }
}

export type ColumnSetupType<T> = ColumnDef<T> & {
  headerTooltip?: string;
  accessorKey?: keyof T;
};

export type TableOptionsType = TableOptions<any> & {
  state: Partial<TableState>;
  initialState: InitialTableState;
};
